export default {
  'receipt.title': '回执信息',
  'receipt.btn.add': '增加回执信息',
  'receipt.btn.import': '导入回执信息',
  'receipt.btn.export': '导出回执信息',
  'receipt.input.placeholder': '请输入回执信息',
};
